import { createSelector } from 'reselect'

const selectQuestions = (state) => state.tasteProfileOnboarding.questions
const getCurrentQuestionSlug = (state, nextProps) => nextProps.params.question

export const selectCurrentQuestion = createSelector(
  [selectQuestions, getCurrentQuestionSlug],
  (questions, questionSlug) => {
    if (!questionSlug) {
      return {}
    }
    return questions.find((v) => v.url === questionSlug) || {}
  }
)
